function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var RequestInterceptor = /*#__PURE__*/function () {
  function RequestInterceptor() {
    _classCallCheck(this, RequestInterceptor);
  }

  _createClass(RequestInterceptor, null, [{
    key: "register",
    value: function register(interceptor) {
      this.interceptor = interceptor;
    }
  }, {
    key: "get",
    value: function get() {
      return this.interceptor;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.interceptor = undefined;
    }
  }]);

  return RequestInterceptor;
}();